import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'
import dashboardRoutes from '@/router/dashboardRoutes'
import authRoutes from '@/router/common/authRoutes'
import accountRoutes from '@/router/common/accountRoutes'
import profileRoutes from '@/router/common/profileRoutes'
import folderSetupRoutes from '@/router/repair-file-module/folderSetupRoutes'
import folderLifecycleRoutes from '@/router/repair-file-module/folderLifecycleRoutes'
import transporterRoutes from '@/router/repair-file-module/transporterRoutes'
import rentalRoutes from '@/router/rental-file-module/rentalRoutes'
import recyclingRoutes from '@/router/recycling-file-module/recyclingRoutes'
import { checkPermission } from '@/components/utils/globalFunction'

const routes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...accountRoutes,
  ...profileRoutes,
  ...folderSetupRoutes,
  ...folderLifecycleRoutes,
  ...transporterRoutes,
  ...rentalRoutes,
  ...recyclingRoutes
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const loggedIn = store.state.auth.auth.status.loggedIn

  const path_split = to.path.split('/')
  if (
    path_split.length === 3 &&
    path_split[1] === 'public' &&
    (path_split[2] === 'client-package-select' || path_split[2] === 'client-option-select')
  ) {
    next()
  } else if (
    path_split.length === 4 &&
    path_split[1] === 'public' &&
    ((path_split[2] === 'rental-module' && path_split[3] === 'add-product-picture') ||
      (path_split[2] === 'repair-prospect' &&
        (path_split[3] === 'add-product-picture' ||
          path_split[3] === 'manufacturer-prospect-option-select')))
  ) {
    next()
  } else if (to.meta['requiresAuth'] && !loggedIn) {
    next('/')
  } else if (!to.meta['requiresAuth'] && loggedIn) {
    next('/dashboard')
  } else {
    if (to.meta['permissions']) {
      if (checkPermission(to.meta['permissions'])) {
        next()
      } else {
        next('/')
      }
    } else {
      next()
    }
  }
})

export default router
